import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  drawer: {
    height: `calc(var(--vh) - ${theme.mixins.toolbar.minHeight}px)`,
    overflowY: "auto",
    borderRight: "1px solid rgba(0,0,0,0.12)",
    [theme.breakpoints.down("lg")]: {
      marginTop: `${theme.mixins.toolbar.minHeight}px`,
      width: 296,
    },
  },
  drawerContainer: {
    backgroundColor: "#fff",
    paddingTop: 0,
    paddingBottom: 0,
  },
  linkList: {
    padding: 0,
    margin: theme.spacing(3, "auto", 4.5, "auto"),
  },
  navItem: {
    ...theme.typography.body2,
    color: theme.palette.text.primary,
    width: "auto",
  },
}));

export default useStyles;
